angular.module('bribac.components.newCalendar', [
    'ui.calendar',
    'bribac.services.api'
])
  .component('newCalendar', {
      templateUrl: 'new-calendar-component.html',
      controller: 'NewCalendarCtrl',
      bindings: {
          subject: '<',
          fetchData: '&'
      }
  })

  .controller('NewCalendarCtrl', function(
      $translate,
      $scope,
      newTestOverviewPopup,
      uiCalendarConfig,
      $timeout,
      api
  ) {
      const $ctrl = this
      $ctrl.fixDates = []
      $ctrl.events = []
      $ctrl.allTests = []
  
      this.$onInit = function() {
          if (this.subject != null) {
              $scope.subject = this.subject;
              $scope.tests = this.subject.tests;
              $scope.optionalTests = this.subject.optionalAlcoholSamples;
              $scope.fetchData = this.fetchData.bind(this)
              initCalendar(false);
          }
      };

      $scope.$watch('subject', function(newVal, oldVal) {
        $scope.tests = newVal.tests;
        $scope.optionalTests = newVal.optionalAlcoholSamples;
        initCalendar(true);
      }, true);
      function groupByDate(events) {
        return events.reduce((groups, record) => {
            const date = record.start.substring(0, 10);
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(record);
            return groups;
        }, {});
    }
      function initCalendar(justChangeEvents) {
          $ctrl.allTests = [];
          if ($scope.tests != null) {
                $ctrl.allTests.push(...$scope.tests);
            }
            if ($scope.optionalTests != null) {
                $ctrl.allTests.push(...$scope.optionalTests);
            }

            if ($scope.subject != null) {
                $ctrl.subject = $scope.subject
            }

            $ctrl.allTests.sort( (a, b) =>
                new Date(a.opensOnDate != null ? a.opensOnDate : a.dateCreated) -
            new Date(b.opensOnDate != null ? b.opensOnDate : b.dateCreated)
        );


            $ctrl.events = [];
            for (const test of  $ctrl.allTests) {
                let optional = test.optional != null ? test.optional : false
                $ctrl.events.push({
                    id: `dot-state-id-${test.id}-${test.opensOnDate != null ? test.opensOnDate : test.dateCreated}`,
                    realId: test.id,
                    title: '',
                    start: test.opensOnDate != null ? test.opensOnDate : test.dateCreated,
                    date: test.opensOnDate != null ? test.opensOnDate : test.dateCreated,
                    state: test.state,
                    optional: optional,
                    sample: optional ? null : test.sample,
                    bacLimitPassed: test.bacLimitPassed,
                    frsResult: test.faceRecognition ? test.faceRecognition.result : null,
                    dateCreated: optional ? test.dateCreated : null,
                    receivedAt: optional ? test.receivedAt : null
                })
            }


        const groupedEvents = groupByDate($ctrl.events);
        $ctrl.fixDates = groupByDate($ctrl.events)
        const finalEvents = $ctrl.events.filter((event, index, self) =>
            index === self.findIndex((e) => (
                e.start.substring(0, 10) === event.start.substring(0, 10)
            ))
        );

        $scope.eventSources = [
            {
                events: finalEvents
            }
        ];

                $scope.uiConfig = {
                    calendar: {
                        height: 650,
                        header:{
                            left: 'prevYear, nextYear',
                            center: 'title',
                            right: 'today prev,next'
                        },
                        buttonText: { today: $translate.instant('today', null, "", "", "") },
                        firstDay: 1,
                        displayEventTime: false,
                        displayEventEnd: false,
                        fixedWeekCount: false,
                        showNonCurrentDates: false,
                        viewRender: (view, element) => {

                        const startDate = view.start
                        const endDate = view.end
                        $scope.fetchData({d1:startDate, d2:endDate})
                    },
                        eventRender: function(event, element) {
                            const date = event.date.substring(0, 10);
                            const groupedEvent = $ctrl.fixDates[date];

                            function timeManipulated(test) {
                                if (test.optional) {
                                    if (!test.dateCreated || !test.receivedAt) {
                                        return false
                                    }
                                    return isManipulated(new Date(test.dateCreated), new Date(test.receivedAt))
                                }

                                if (!test.sample) {
                                    return false
                                }

                                let created = new Date(test.sample.dateCreated)
                                let received = new Date(test.sample.receivedAt)
                                return isManipulated(created, received);
                            }

                            function isManipulated(created, received) {
                                return moment(created).add(30, 'm').toDate() < received
                                    || created > received;
                            }

                            if (groupedEvent) {
                                const count = groupedEvent.length;
                                let dots = '';
                                const fcContent = element.find('.fc-content');
                                for (let i = 0; i < count; i++) {
                                    const specificEvent = groupedEvent[i];

                                    let classes = "dot-state"

                                    if (specificEvent.state === "FAILED") {
                                        if (specificEvent.bacLimitPassed) {
                                            classes += " dot-state-frs-failed"
                                        } else {
                                            classes += " dot-state-failed"
                                        }
                                    }
                                    if (specificEvent.state === "EXPIRED") {
                                        classes += " dot-state-expired";
                                    }
                                    if (specificEvent.state === "OPEN") {
                                        classes += " dot-state-open";
                                    }
                                    if (specificEvent.state === "PASSED") {
                                        if (specificEvent.bacLimitPassed) {
                                            classes += " dot-state-passed";
                                        } else {
                                            classes += " dot-state-failed"
                                        }
                                    }
                                    if (specificEvent.state === "INACTIVE") {
                                        classes += " dot-state-inactive";
                                    }
                                    if (specificEvent.optional) {
                                        classes += " dot-state-border";
                                    }
                                    if(specificEvent.optional && timeManipulated(specificEvent)){
                                        classes += " dot-state-border-time-manipulated";
                                    }
                                    if(!specificEvent.optional && timeManipulated(specificEvent)){
                                        classes += " dot-state-time-manipulated";
                                    }
                                    dots += `<span id=${specificEvent.id} class="${classes}" unqid=${specificEvent.start}></span>`;
                                }
                                fcContent[0].addEventListener('click', function(event) {
                                    if (event.target.classList.contains('dot-state')) {
                                        const dotId = event.target.id;
                                       const result = $ctrl.events.filter(ev => ev.id === dotId);
                                        if (result.length > 0) {
                                            let allTestsResult =  $ctrl.allTests.filter(t => t.id === result[0].realId);
                                            if (allTestsResult.length == 1) {
                                                $ctrl.newTestOverviewPopup(allTestsResult[0], $ctrl.subject);
                                            } else if(allTestsResult.length > 1) {
                                                allTestsResult =  allTestsResult.filter(t =>
                                                     t.opensOnDate == result[0].start || t.dateCreated == result[0].start);
                                                $ctrl.newTestOverviewPopup(allTestsResult[0], $ctrl.subject);
                                            }
                                        }
                                    }
                                });
                                fcContent.append(dots);
                            }
                        }
                    }
                };
            if (justChangeEvents) {
                if (uiCalendarConfig.calendars['myCalendar'] != null) {

                $timeout(function() {
                    uiCalendarConfig.calendars['myCalendar'].fullCalendar('removeEvents');
                        uiCalendarConfig.calendars['myCalendar'].fullCalendar('addEventSource', $scope.eventSources[0]);
                        uiCalendarConfig.calendars['myCalendar'].fullCalendar('refetchEvents');
                        uiCalendarConfig.calendars['myCalendar'].fullCalendar('rerenderEvents');
                    })
                }
            }

      }

      $ctrl.newTestOverviewPopup = function(test, subject) {
          newTestOverviewPopup(test, subject);
      }
  })
